import DegreeApprenticeshipLandingPage from './DegreeApprenticeshipLandingPage';
export default DegreeApprenticeshipLandingPage;
